import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { ResourceRecord } from '../entities/records';
import * as selectors from '../entities/Resource/selectors';

function mapStateToProps(state, { resourceId }) {
  return {
    resource: selectors.resourceById(state, resourceId),
  };
}

export default compose(
  setPropTypes({
    resourceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    resource: PropTypes.instanceOf(ResourceRecord),
  }),
)(mapStateToProps);
